import ApiService from '@/service/apiService';
import Api from '@/config/api';

export default {
  state: {
    users: [],
    allUsers: [],
    assignedUsers: [],
    currentUser: null,
    currentUserIsAdmin: false,
    isCreateReviewUser: false,
    companyContactAuthority: false,
    userContactAuthority: false,
    jdMatchingAuthority: false,
    occupation: [],
    reviewListUsers: [],
    reviewLists: [],
    reviewListUserModel: [],
    assignedReviewLists: [],
  },
  getters: {
    getUsers(state) {
      return state.users;
    },
    getAllUsers(state) {
      return state.allUsers;
    },
    getAllAssignedUsers(state) {
      return state.assignedUsers
    },
    getReviewListUsers(state) {
      return state.reviewListUsers;
    },
    getCurrentUser(state) {
      return state.currentUser;
    },
    currentUserIsAdmin(state) {
      return state.currentUserIsAdmin;
    },
    isCreateReviewUser(state) {
      return state.isCreateReviewUser;
    },
    getCompanyContactAuthority(state) {
      return state.companyContactAuthority;
    },
    getUserContactAuthority(state) {
      return state.userContactAuthority;
    },
    getJdMatchingAuthority(state) {
      return state.jdMatchingAuthority;
    },
    getOccupations(state) {
      return state.occupation;
    },
    getReviewLists(state) {
      return state.reviewLists;
    },
    getReviewListUserModel(state) {
      return state.reviewListUserModel;
    },
    getAssignedReviewLists(state) {
      return state.assignedReviewLists;
    },
    getReviewListSearchQuery(state) {
      return state.reviewListSearchQuery;
    },
    getReviewListSortMode(state) {
      return state.reviewListSortMode;
    },
  },
  mutations: {
    setCurrentUser(state, data) {
      // eslint-disable-next-line
      state.currentUser = data;
      // eslint-disable-next-line
      state.currentUserIsAdmin = data.isAdmin;
      state.isCreateReviewUser = data.isCreateReviewUser;
      state.companyContactAuthority = data.companyContactAuthority;
      state.userContactAuthority = data.userContactAuthority;
      state.jdMatchingAuthority = data.jdMatchingAuthority;
    },
    setUser(state, data) {
      // eslint-disable-next-line
      state.users.push(data);
    },
    setUsers(state, data) {
      // eslint-disable-next-line
      state.users = data;
    },
    setAllUsers(state, data) {
      state.allUsers = data;
    },
    setAssignedUsers(state, data) {
      state.assignedUsers = data;
    },
    setReviewListUsers(state, data) {
      state.reviewListUsers = data;
    },
    unsetUser(state, data) {
      const usr = state.users.find((user) => user.id === data.id);
      const index = state.users.indexOf(usr);
      const findIndex = state.reviewListUsers.findIndex(
        (user) => user.id === data.id
      );
      if (findIndex > -1) {
        state.reviewListUsers.splice(index, 1);
      }
      if (index > -1) {
        state.users.splice(index, 1);
      }
    },
    updateUserList(state, data) {
      const index = state.users.findIndex((user) => user.id === data.id);
      if (index < 0) {
        state.users = [data, ...state.users]; // prepend new user
      } else {
        // immutably replace the updated user
        const updatedUsers = [...state.users];
        updatedUsers[index] = data;
        state.users = updatedUsers;
      }
    },
    updateReviewListUsers(state, data) {
      const index = state.reviewListUsers.findIndex((user) => user.id === data.id);
      if (index < 0) {
        state.reviewListUsers = [data, ...state.reviewListUsers]; // prepend new user
      } else {
        // immutably replace the updated user
        const updatedUsers = [...state.reviewListUsers];
        updatedUsers[index] = data;
        state.reviewListUsers = updatedUsers;
      }
    },
    // updateReviewListUsers(state, data) {
    //   if (!data.isCreateReviewUser) {
    //     const index = state.reviewListUsers.findIndex(
    //       (user) => user.id === data.id
    //     );
    //     // const index = state.users.indexOf(user);
    //     if (index < 0) {
    //       state.reviewListUsers.unshift(data);
    //     } else {
    //       state.reviewListUsers[index] = data;
    //     }
    //   } else {
    //     const index = state.reviewListUsers.findIndex(
    //       (user) => user.id === data.id
    //     );
    //     if (index >= 0) {
    //       state.reviewListUsers.splice(index, 1);
    //     }
    //   }
    // },
    unsetReviewList(state, data) {
      const reviewList = state.reviewLists.find(
        (list) => list._id === data._id
      );

      if (!reviewList) return;

      const deletedPosition = reviewList.position;

      // Update positions of lists that had higher positions
      state.reviewLists.forEach((list) => {
        if (list.position > deletedPosition) {
          list.position = list.position - 1;
        }
      });

      // Remove the deleted review list from array
      const index = state.reviewLists.indexOf(reviewList);
      if (index > -1) {
        state.reviewLists.splice(index, 1);
      }
    },
    updateReviewList(state, data) {
      const index = state.reviewLists.findIndex(
        (list) => list._id === data._id
      );

      if (index < 0) {
        // Shift all existing positions up by 1 to make room for the new entry at position 1
        const shifted = state.reviewLists.map((list) =>
          Object.assign({}, list, { position: (list.position || 1) + 1 })
        );
        state.reviewLists = [data, ...shifted];
      } else {
        // Replace item immutably to trigger reactivity
        const updatedList = [...state.reviewLists];
        updatedList[index] = data;
        state.reviewLists = updatedList;
      }
    },

    setOccupation(state, data) {
      state.occupation = data;
    },
    setReviewLists(state, data) {
      state.reviewLists = data;
    },
    setReviewListUserModel(state, data) {
      state.reviewListUserModel = data;
    },
    setAssignedReviewLists(state, data) {
      state.assignedReviewLists = data;
    },
    clearAll(state) {
      /* eslint-disable */
      state.users = [];
      state.currentUser = null;
      state.currentUserIsAdmin = false;
      state.isCreateReviewUser = false;
      state.individualContactAuthority = false;
      state.jdMatchingAuthority = false;
      (state.reviewListUsers = []),
        (state.reviewLists = []),
        (state.reviewListUserModel = []);
      state.occupation = [];
    },
  },
  actions: {
    async loadCurrentUser({ state, commit }) {
      try {
        if (state.currentUser === null) {
          const user = await ApiService.get(Api.endpoints.CURRENTUSER);
          commit('setCurrentUser', user.data.data);
          return user.data.data;
        }
        return state.currentUser;
      } catch (error) {
        console.log(error);
      }
    },
    async loadUsers({ commit }) {
      try {
        const users = await ApiService.get(Api.endpoints.USERS);
        commit('setUsers', users.data.data);
      } catch (error) {
        console.log(error);
      }
    },
    async loadAllUsers({ commit }) {
      try {
        const users = await ApiService.get(Api.endpoints.ALLUSERS);
        commit('setAllUsers', users.data.data);
      } catch (error) {
        console.log(error);
      }
    },
    async loadAssingedUsers({ commit }) {
      try {
        const users = await ApiService.get(Api.endpoints.ASSIGNEDUSERS);
        commit('setAssignedUsers', users.data.data);
      } catch (error) {
        console.log(error);
      }
    },
    async reviewListUsers({ commit }) {
      try {
        const users = await ApiService.get(Api.endpoints.REVIEW_LIST_USERS);
        commit('setReviewListUsers', users.data.data);
      } catch (error) {
        console.log(error);
      }
    },
    async loadReviewLists({ commit }) {
      try {
        const reviewLists = await ApiService.get(Api.endpoints.REVIEW_LIST);
        commit('setReviewLists', reviewLists.data.data);
      } catch (err) {
        console.log(err);
      }
    },
    async loadAssignedReviewLists({ commit }) {
      try {
        const response = await ApiService.get(Api.endpoints.ASSIGNED_REVIEW_LIST);
        commit('setAssignedReviewLists', response.data.data);
      } catch (err) {
        console.log(err);
      }
    },
    async loadOccupations({ commit }) {
      try {
        const occupations = await ApiService.get(Api.endpoints.OCCUPATION);
        commit('setOccupation', occupations.data.data);
      } catch (err) {
        console.log(err);
      }
    },
    setUserData({ commit }, data) {
      commit('setCurrentUser', data);
    },
    updateUserScoutCheckBox({ commit, state }, value) {
      if (state.currentUser) {
        const updatedUser = {
          ...state.currentUser,
          scoutCheckBox: value
        };
        commit('setCurrentUser', updatedUser);
      }
    },
    updateUserScoutPeriodEndingDisplay({ commit, state }, value) {
      if (state.currentUser) {
        const updatedUser = {
          ...state.currentUser,
          scoutPeriodEndingDisplay: value
        };
        commit('setCurrentUser', updatedUser);
      }
    },
  },
};
